var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-options",class:( _obj = {}, _obj[_vm.size] = true, _obj )},_vm._l((_vm.radioOptions),function(option){return _c('Button',{key:option.id,class:{ active: option.active },attrs:{"plain":""},on:{"click":function($event){return _vm.select(option)}}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }